<template>
  <figure @click='next()'>
    <transition name='slow' v-for='(filename, index) in filenames' :key='index'>
      <srcset v-show='index==current'
              :file='page.files[filename]'
              sizes='60vw' />
    </transition>
  </figure>
</template>


<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc,
  props: ['page', 'filenames'],
  data: function() {
    return {
      current: 0,
    }
  },
  methods: {
    clear(){
      this.current = 0;
    },
    next(){
      this.current = (this.current + 1 < this.filenames.length) ? this.current + 1 : 0;
    },
    prev(){
      this.current = (0 < this.current - 1) ? this.current - 1 : this.filenames.length;
    },
  }
}
</script>

<style scoped>
  figure {
    height: 40rem;
    margin-top: 2rem;
    margin-bottom: 0rem;
    position: relative;
    box-sizing: border-box;
  }

  figure div {
    max-width: 60rem;
    position: absolute;
    top: 0;
    padding-top: 1rem;
    padding-bottom: 1.25rem;
    box-sizing: border-box;
  }

</style>
